import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'doubleChamiliApostrofos';
const args = {};

export class DoubleChamiliApostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
